import { ModalContext } from '@context/modalContext';
import { cn, XIcon } from '@moreharvest/component-library';
import React, { useContext, useEffect, useRef } from 'react';

const modalWrapperClasses = cn(
    'fixed inset-0 w-screen h-screen',
    'bg-black/20 flex justify-center items-center'
);

const modalClasses = cn(
    'bg-neutral-50 dark:bg-neutral-50-dark',
    'rounded-2xl w-[90%] max-w-[424px]',
    'flex flex-col gap-y-8 py-8 px-4',
    'relative break-words',
    'shadow-[0px_4px_8px_rgba(0,0,0,0.05),0px_10px_40px_rgba(0,0,0,0.05)]'
);

const Modal = ({
    children,
    onClose,
    id,
}: {
    children: React.ReactNode;
    onClose?: () => void;
    id?: string;
}) => {
    const { setModal } = useContext(ModalContext);
    onClose =
        onClose ||
        (() => {
            setModal(null);
        });

    const modalRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (e: MouseEvent) => {
            if (
                modalRef.current &&
                !modalRef.current.contains(e.target as Node)
            ) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const handlePopState = () => {
            setModal(null);
        };

        window.addEventListener('popstate', handlePopState);
        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [setModal]);

    return (
        <div className={modalWrapperClasses}>
            <div className={modalClasses} ref={modalRef}>
                <button
                    onClick={() => {
                        onClose && onClose();
                        setModal(null);
                    }}
                    id={id}
                >
                    <XIcon className="w-4 stroke-neutral-800 dark:stroke-neutral-800-dark absolute right-4 top-4 cursor-pointer" />
                </button>
                {children}
            </div>
        </div>
    );
};

export default Modal;
